import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'

export const getNoticeTypeInfo = async (params: object) => {
  return await GET({ url: Api.getNoticeTypeInfo, params, showError: false })
}
export const getList = async (params: object) => {
  return await GET({ url: Api.getList, params, showError: false })
}
export const pullData = async (params: object) => {
  return await GET({ url: Api.pullData, params, showError: false })
}
